export default {"src":"/_next/static/image/public/images/ic_logout_white.e071dabd758375ab1bfa0fc5c7bf6202.svg","height":20,"width":20};